module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_6_4.ae3c9292.png";